export function openSchemeForInstallCheck(
  scheme,
  { isSafariBrowser, documentRef = document, windowRef = window } = {}
) {
  if (!isSafariBrowser) {
    windowRef.location.href = scheme
    return null
  }

  const iframe = documentRef.createElement('iframe')
  iframe.style.display = 'none'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = 'none'
  iframe.style.position = 'absolute'
  iframe.style.left = '-9999px'
  iframe.src = scheme

  documentRef.body.appendChild(iframe)
  return iframe
}

export function removeSchemeIframe(iframe, documentRef = document) {
  if (iframe && documentRef.body.contains(iframe)) {
    documentRef.body.removeChild(iframe)
  }
}
